module.exports = __webpack_public_path__ + "static/img/icon_list_bullet@2x.7db65ce.png";